export interface Whatsapp {
  id: string;
  name: string;
  qrCode: string;
  status: WhatsappStatus;
  phone: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export enum WhatsappStatus {
  DISCONNECTED = 'close',
  CONNECTING = 'connecting',
  CONNECTED = 'open',
  FAILED = 'failed',
}